export const MUTATION_KEYS = {
  ADD_TICKETS: 'add-tickets',
  MODIFY_CART: 'modify-cart',
  CHECKOUT: 'checkout',
  DELETE_CART: 'delete-cart',
  REMOVE_TICKETS: 'remove-tickets',
  CREATE_USER: 'create-user',
  UPDATE_USER: 'update-user',
  CREATE_GIFT_RECIPIENT: 'create-gift-recipient',
  REDEEM_PERKS: 'redeem-perks',
  APPLY_PROMO_CODES: 'apply-promo-codes',
  GET_GIFT_CARD_BALANCE: 'get-gift-card-balance',
}

export const QUERY_KEYS = {
  USER: 'user',
  CART: 'cart',
  CALENDAR: 'calendar',
  CALENDAR_META: 'calendar-meta',
  CALENDAR_PRICING: 'calendar-pricing',
  TIMESLOTS: 'timeslots',
  TICKETS: 'tickets',
  TICKETS_AND_ADDONS: 'tickets-and-addons',
  ADDONS: 'addons',
  GLOBAL_NOTIFICATIONS: 'global-notifications',
  ORDER_DETAILS: 'order-details',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  EXPERIMENT_VARIANT: 'experiment-variant',
  DISMISSED_PORTAL_MODAL_QUERY_KEY: ['dismissedPortalModal'] as const,
}
